/*
 * @Author: Teemo Ding
 * @Date: 2022-04-15 14:44:16
 * @LastEditTime: 2022-04-20 16:11:20
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionDetail/AccountActivities/index.tsx
 */
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { columns } from '../config';
import css from '../style.module.less';

const AccountActivities = ({ loginSessions }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      rightPart={''}
      title={getI18n('usersAndPermissions.list.accountActivities')}>
      {getI18n('usersAndPermissions.detail.recentLoginSessions')}
      <EditableTable
        disableAdd
        data={loginSessions}
        columns={columns({ getI18n })}
        id='PaymentListTable'
        rowKey='uuid'
      />
    </SectionWrapper>
  );
};

export default AccountActivities;
